export default __webpack_public_path__ + "static/media/Aura-Egg__27.ab5a7c54.png";